import './minicart.scss';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
class Minicart {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-cart',
            breakpoint: '1024',
            minicartActiveClass: 'minicart__overlay--is-active',
            minicartActiveFromProductClass: 'minicart__overlay--added',
            minicartBreakpoint: 1024,
            minicartClose: 'close',
            minicartOpenFull: 'full',
            minicartExpander: 'expander',
            siteheaderHiddenClass: 'siteheader--hidden'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$minicart = element;
        this.$minicartExpander = document.querySelector('[' + this.settings.initAttr + '="' + this.settings.minicartExpander + '"]');
        this.$minicartClose = document.querySelector('[' + this.settings.initAttr + '="' + this.settings.minicartClose + '"]');
        this.$minicartOpenFull = document.querySelector('[' + this.settings.initAttr + '="' + this.settings.minicartOpenFull + '"]');
        this.$siteheader = document.querySelector('[data-siteheader="root"]');
        this.lastFocusedElement = null;
        this.initialize();
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        if (this.$minicartExpander) {
            const breakpointMaxWidth = window.matchMedia('(max-width: ' + this.settings.breakpoint + 'px)');

            if (breakpointMaxWidth.matches) {
                this.$minicartExpander.addEventListener('click', (e) => {
                    if (window.innerWidth < this.settings.minicartBreakpoint) {
                        e.preventDefault();
                        disableBodyScroll(this.$minicart);
                        this.$minicart.classList.add(this.settings.minicartActiveClass);
                    }
                });
            }

            this.$minicartExpander.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    this.lastFocusedElement = document.activeElement;
                    e.preventDefault();

                    if (this.$minicart.classList.contains(this.settings.minicartActiveClass)) {
                        this.$minicart.classList.remove(this.settings.minicartActiveClass);
                    } else {
                        this.$minicart.classList.add(this.settings.minicartActiveClass);
                    }
                }
            });
        }

        if (this.$minicartClose) {
            this.$minicartClose.addEventListener('click', () => {
                if (this.$minicart.classList.contains(this.settings.minicartActiveClass)) {
                    clearAllBodyScrollLocks();
                    this.$minicart.classList.remove(this.settings.minicartActiveClass);
                    this.$minicart.classList.remove(this.settings.minicartActiveFromProductClass);

                    if (this.lastFocusedElement) {
                        this.lastFocusedElement.focus();
                    }
                }
            });
        }

        if (this.$minicartOpenFull) {
            this.$minicartOpenFull.addEventListener('click', () => {
                disableBodyScroll(this.$minicart);
                this.$minicart.classList.remove(this.settings.minicartActiveFromProductClass);
                this.$minicart.classList.add(this.settings.minicartActiveClass);
                this.$siteheader.classList.remove(this.settings.siteheaderHiddenClass);
            });
        }

        const breakpointMinWidth = window.matchMedia('(min-width: ' + this.settings.breakpoint + 'px)');

        if (breakpointMinWidth.matches) {
            this.$minicart.addEventListener('mouseleave', () => {
                clearAllBodyScrollLocks();
                this.$minicart.classList.remove(this.settings.minicartActiveClass);
            });
        }

        document.addEventListener('keydown', (e) => {
            let isEscape = false;

            if ('key' in e) {
                isEscape = (e.key === 'Escape' || e.key === 'Esc');
            } else {
                isEscape = (e.keyCode === 27);
            }

            if (isEscape) {
                if (this.$minicart.classList.contains(this.settings.minicartActiveClass)) {
                    this.$minicart.classList.remove(this.settings.minicartActiveClass);

                    if (this.lastFocusedElement) {
                        this.lastFocusedElement.focus();
                    }
                }
            }
        });
    }
}

export { Minicart };
